import React from 'react'
import { useLanguage } from '../../hooks/useLanguage'

const Hero: React.FC = () => {
  const { t } = useLanguage()
  
  const scrollToTrips = (e: React.MouseEvent) => {
    e.preventDefault()
    const tripsSection = document.getElementById('trips')
    if (tripsSection) {
      const headerHeight = 80 // Altezza approssimativa dell'header
      const elementPosition = tripsSection.offsetTop - headerHeight
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div id="banner-section" className="banner relative min-h-screen flex items-start justify-center pt-32">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/home-page.webp" 
          alt="Abruzzo Coast" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>
      
      {/* Banner Text */}
      <div className="banner-text relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="title text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-6 leading-tight">
          {t('landing.hero.title')}
        </h1>
        <p className="subtitle text-xl md:text-2xl lg:text-3xl mb-8 text-gray-200">
          {t('landing.hero.subtitle')}
        </p>
        <a 
          href="#trips" 
          onClick={scrollToTrips}
          className="primary-btn bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 inline-block cursor-pointer"
        >
          {t('landing.hero.cta')}
        </a>
      </div>
    </div>
  )
}

export default Hero 